import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: `2.5px 2.5px 8px ${theme.palette.grey.light}`,
    width: "100%",
  },
  cardHeader: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.header,
    color: theme.palette.text.secondary,
    ...theme.typography.button,
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1),
    },
  },
  cardHeaderTitle: {
    textAlign: "left",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  tableContainer: {
    padding: "1% 3% 1% 3%",
    overflowX: "auto",
  },
  toolbar: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    width: "100%",
    padding: theme.spacing(1, 0),
    flexWrap: "wrap",
  },
  searchRow: {
    flex: "1 1 auto",
  },
  searchField: {
    width: "100%",
  },
  searchButtonCell: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      paddingTop: 0,
    },
  },
  searchButton: {
    minWidth: 96,
    height: 40,
  },
  clearButton: {
    minWidth: 80,
    height: 40,
  },
  paginationCell: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flex: "0 0 auto",
    paddingTop: theme.spacing(1),
  },
  pagination: {},
  table: {
    tableLayout: "auto",
    minWidth: "100%",
  },
  tableHeader: {
    ...theme.typography.button,
    whiteSpace: "nowrap",
  },
  headerCell: {
    ...theme.typography.button,
    whiteSpace: "nowrap",
    color: theme.palette.text.secondary,
  },
  numericHeaderCell: {
    ...theme.typography.button,
    whiteSpace: "nowrap",
    color: theme.palette.text.secondary,
    textAlign: "right",
  },
  numericSortLabel: {
    flexDirection: "row-reverse",
    "& .MuiTableSortLabel-icon": {
      marginRight: theme.spacing(0.5),
      marginLeft: 0,
    },
  },
  tableRow: {
    borderBottom: `1px solid ${theme.palette.header}`,
  },
  tableCell: {
    borderBottom: "none",
    whiteSpace: "break-spaces",
  },
  numericCell: {
    borderBottom: "none",
    textAlign: "right",
    fontVariantNumeric: "tabular-nums",
  },
  centerContentColumn: {
    textAlign: "center",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
  },
  noDataMessage: {
    paddingTop: theme.spacing(2),
    fontSize: "1.5rem",
    color: theme.palette.text.secondary,
  },
  loadingBar: {
    width: "100%",
    opacity: 0.5,
  },
}));
